import util from '@bmp-vue/core/api/util'

const controller = 'Duplicatas'
export default Object.assign({}, util.GetCrud(controller, null), {
    GetHistorico: function(codigo) {
        return util.Axios.GetAll(controller + `/${codigo}/Historico`)
    },
    GetDuplicatasExcel: function (dto) {
        return util.Axios.GetAll(controller + '/Excel', dto)
    },
    GetDuplicatasLogsAws: function (dto) {
        return util.Axios.GetAll(controller + '/Lambda', dto)
    },
    PostEcoDup: function (dto) {
        return util.Axios.Post(controller + "/Eco", dto)
    },
})
